import ICONS from "../../../../../assets/Icons";
import { errorcode } from "../../../../../utils/configurationProvider";
import PrimaryButton from "../../../../_utils/CommonButtons/PrimaryButton";
import Loader from "../../../../Loader/Index";

const FecthingPage = ({
  fetchPageEnabled,
  loading,
  isError,
  handleFunction,
  errorData,
}) => {
  return (
    <>
      {fetchPageEnabled ||
      loading ||
      errorData?.status === errorcode?.errorNotFound ? (
        <>
          <div
            className={`flex justify-center items-center  bg-primary-card ${errorData?.status !== errorcode?.errorNotFound ? " opacity-dark-opacity " : ""} absolute w-width-full h-height-full z-z-index-header rounded-b-border-radius-md`}
          ></div>
          <div className="flex flex-col absolute justify-center items-center w-width-full h-height-full z-z-index-header opacity-base-opacity">
            {errorData?.status === errorcode?.errorNotFound ? (
              <div className="flex flex-col gap-y-gap-sm mx-auto justify-center items-center">
                <img
                  className="h-graphic-rectangle-height-md w-graphic-width-md"
                  src={ICONS?.NO_STATISTICS_AVAILABLE}
                  alt=""
                />
                <div className="flex flex-col gap-gap-xs px-padding-xs text-text-primary text-font-xs font-semibold text-center">
                  <span>
                    No statistics available due to the absence of data.
                  </span>
                  <span>Once data is present, statistics will appear.</span>
                </div>
              </div>
            ) : (
              <>
                <div className="text-text-primary text-font-sm font-semibold px-padding-lg text-center">
                  {isError
                    ? "Failed to fetch for the current parameters. Change parameters or try again later."
                    : !fetchPageEnabled
                      ? ""
                      : "Click below to fetch the updated statistics"}
                </div>
                <div
                  className={`${!fetchPageEnabled ? "mt-marging-base" : "mt-margin-md"}`}
                >
                  {loading ? (
                    <Loader
                      width="var(--icon-lg)"
                      height="var(--icon-lg)"
                    />
                  ) : (
                    <PrimaryButton
                      btnText={"Fetch"}
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--primary-nav-act)"}
                      handleFunction={handleFunction}
                      hoverOption="white"
                      isLoading={loading}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </>
      ) : null}
    </>
  );
};

export default FecthingPage;
